import { isValue } from './isValue';
import { getNumberFromString } from './formatNumbers';

export function monthlyMortgageCalculator(
  annualInterestRate,
  principal,
  period
) {
  //check args
  // if (period < 1 && !secondMortgageInterestOnly) {
  //   console.error('mortgage period must be greater than one month', period);
  //   return null;
  // }
  if (annualInterestRate < 0 || annualInterestRate > 1) {
    console.error('Annual interest rate should be between 0 and 1');
    return null;
  }

  const periodInterestRate = annualInterestRate / 12;

  const numerator =
    periodInterestRate * Math.pow(1 + periodInterestRate, period);
  const denominator = Math.pow(1 + periodInterestRate, period) - 1;
  const coeffecient = numerator / denominator;
  const montlhyMortageAmount = principal * coeffecient;
  return montlhyMortageAmount;
}

export function amortizedAnnualValue(
  appreciationRate,
  purchasePrincipal,
  periodInYears
) {
  //a = p (1 + r/n) power period
  const coeffecient = Math.pow(1 + appreciationRate, periodInYears);
  return purchasePrincipal * coeffecient;
}
export function mortgagePrincipalOutstanding(
  interestRate,
  principal,
  mortgagePayment,
  months
) {
  const monthlyInterestRate = interestRate / 100 / 12; // 0.00000001 absolute value

  let p = months;
  let mortgagePrincipal = principal;

  while (p > 0) {
    const monthlyInterestPayment = mortgagePrincipal * monthlyInterestRate;
    const monthlyPrincipalReduction = mortgagePayment - monthlyInterestPayment;
    mortgagePrincipal = mortgagePrincipal - monthlyPrincipalReduction;
    p -= 1;
  }
  return mortgagePrincipal;
}

export function newMonthlyMortgageCalculator(
  annualInterestRate,
  principal,
  period
) {
  //check args
  if (period < 1) {
    console.error('mortgage period must be greater than one month', period);
    return null;
  }
  if (annualInterestRate < 0 || annualInterestRate > 1) {
    console.error('Annual interest rate should be between 0 and 1');
    return null;
  }

  const periodInterestRate = annualInterestRate / 12;

  const numerator =
    periodInterestRate * Math.pow(1 + periodInterestRate, period);
  const denominator = Math.pow(1 + periodInterestRate, period) - 1;
  const coeffecient = numerator / denominator;
  const montlhyMortageAmount = principal * coeffecient;
  return Math.round(montlhyMortageAmount * 100) / 100;
}

export function mortgageFormSectionCalculator(
  mortgageAmount,
  interestRate,
  interestOnlyMortgage,
  interestOnlyMonthlyPayment,
  amortization
) {
  let monthlyPayment = null;

  if (isValue(interestRate, mortgageAmount, interestOnlyMortgage)) {
    if (!interestOnlyMortgage) {
      const result = monthlyMortgageCalculator(
        interestRate / 100,
        getNumberFromString(mortgageAmount),
        amortization * 12
      );
      monthlyPayment = result;
    } else {
      monthlyPayment = interestOnlyMonthlyPayment
        ? Math.round(mortgageAmount * (interestRate / 1200) * 100) / 100
        : 0;
    }
  }

  return monthlyPayment;
}
